<template>
  <div>
    <div class="top-button" id="serviceRequestButton">
      <service-request-expansion-button
        :protocol="protocol"
        :nmRoute="$router.currentRoute.name"
        @onChangeService="selectServiceRequest"
        @onNew="pageStart"
      ></service-request-expansion-button>
    </div>
    <router-view />
    <service-request-modal-finish
      :protocol="protocol"
      :show="modalFinish"
      @input="(val) => (modalFinish = val)"
    />
  </div>
</template>
<script>
import { Vue, Component } from 'vue-property-decorator'
import ServiceRequestModel from './ServiceRequestModel'
import ServiceRequestController from './ServiceRequestController'
import ServiceRequestModalFinish from './view/ServiceRequestModalFinish'
import ServiceRequestExpansionButton from './view/ServiceRequestExpansionButton'

@Component({
  name: 'ServiceRequestIndex',
  components: {
    ServiceRequestModalFinish,
    ServiceRequestExpansionButton
  },
  props: {
    protocol: {
      type: String,
      required: false,
      default: ''
    }
  }
})
class ServiceRequestIndex extends Vue {
  state = ServiceRequestModel.getInstance();
  controller = ServiceRequestController.getInstance();
  modalFinish = false;

  async mounted () {
    await this.controller.setIndexVue(this)
  }

  showModalFinish ({ protocol }) {
    this.protocol = protocol
    this.modalFinish = true
  }

  closeModalFinish () {
    this.modalFinish = false
  }

  async selectServiceRequest (protocoll, isNew) {
    this.protocol = protocoll.toString()
    const consumerUnit = this.state.serviceRequests[this.protocol].consumerUnit
    if (!isNew && consumerUnit) {
      this.controller.router(
        this.state.serviceRequests[this.protocol].consumerUnits[consumerUnit]
          .router
      )
    } else {
      await this.controller.load(protocoll, this.state.serviceRequests[this.protocol])
      this.state.serviceRequests[this.protocol].consumerUnit = null
      this.controller.router({
        name: 'serviceRequest.list',
        params: { protocol: this.protocol }
      })
    }
  }

  pageStart () {
    this.controller.router({
      name: 'serviceRequest.start'
    })
  }
}
export default ServiceRequestIndex
</script>
<style lang="stylus" scoped>

.top-button {
  position: absolute;
  top: 4.05rem;
  right: 1.5rem;
  z-index: 9;
}
</style>
